module.exports = __webpack_public_path__ + "static/media/ic_template_6.34b512c5.png";